import { getRecords } from './baserow'

export default {
  getNews () {
    return getRecords('News')
  }
}
